import * as React from "react";
import ReactPaginate from "react-paginate";
import * as styles from "./styles";
import { PaginationMeta } from "types";

interface IProps {
  pagination: PaginationMeta;
  onPageChange: ({ selected }: { selected: number }) => void;
}

const Pagination: React.FunctionComponent<IProps> = ({
  pagination,
  onPageChange
}) => (
  <ReactPaginate
    previousLabel="<"
    nextLabel=">"
    nextClassName={styles.paginationNext}
    previousClassName={styles.paginationPrev}
    containerClassName={styles.pagination}
    activeClassName="active"
    breakLabel="..."
    pageCount={Math.ceil(pagination.total / pagination.limit)}
    marginPagesDisplayed={2}
    initialPage={pagination.offset / pagination.limit}
    pageRangeDisplayed={3}
    onPageChange={onPageChange}
  />
);

export default Pagination;
